<template>
  <div>
    <el-dialog title="开票记录" :visible="KPJLMark" :close-on-click-modal="false" width="70%" center @close="closeDialog">
      <div class="addressBox">
        <el-table :data="KPJLDataList" ref="KPJLDataList" @row-click="KPJLxuanzhong" border size="mini" style="" @selection-change="handleSelectionChange" @select='selectGoods':row-style="rowStyle":row-class-name="rowClassName" :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click.stop="delRecordFn(scope.row)">撤销开票</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceNo" label="发票号码" align="center" width="200"></el-table-column>
          <el-table-column prop="invoiceAmount" label="开票金额(元)" align="center" width="">
          </el-table-column>
          <el-table-column prop="wayNumber" label="运单数" align="center" width="">
          </el-table-column>
          <el-table-column prop="" label="发票凭证" align="center" width="">
            <template slot-scope="scope">
              <span style="color: #0c46a2;cursor: pointer;" @click.stop="getKPImgFn(scope.row)">查看</span>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceTime" :formatter="dateTimeFormat" label="开票时间" width="170"></el-table-column>
        </el-table>
        <div style="margin:20px 0;">运单列表：</div>
        <el-table :data="KPJLYunDanDataList" ref="KPJLYunDanDataList" border size="mini" style="" :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="wayNo" label="运单号" align="center" width="230"></el-table-column>
          <el-table-column prop="yfInvoiceAmount" label="开票金额(元)" align="center" width="120">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" align="center" width="130">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" align="center" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightPricingTypeName" label="运费计价" width="100" :formatter="formatterRowEmpty">
            <!-- <template scope="scope">
              0.按吨、1.按车、2.按方、3.按件
              <span v-show="scope.row.freightPricingType == '0'">按吨</span>
              <span v-show="scope.row.freightPricingType == '1'">按车</span>
              <span v-show="scope.row.freightPricingType == '2'">按方</span>
              <span v-show="scope.row.freightPricingType == '3'">按件</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="" label="运费单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                <span v-if="scope.row.freightPricingType == '1'">
                  <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freightAmount" label="运费金额" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceRate" label="支出服务费率(%)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceCharge" label="支出服务费(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightTaxTotal" label="支出总额(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfPaymentAmount" label="已付款金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoPaymentAmount" label="未付款金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceAmount" label="已开票金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoInvoiceAmount" label="未开票金额(元)" width="150" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="generalCarrier" label="承运方" width="220" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceOn" label="发票号" width="230" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
          <el-table-column prop="khyNo" label="三方网货单号" width="160" :show-overflow-tooltip="true" :formatter="formatterRowEmpty">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
    <lookFiles v-if="lookImgMark" :lookImgData = 'lookImgData' :lookImgMark.sync='lookImgMark' :isFK='false'></lookFiles>
  </div>
</template>
<script>
import { getInvoiceRecordMasterList, findWayBusinessList, delInvoiceRecord } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty } from '@/utils/util'
import lookFiles from '@/views/newTMS/publicFiles/caiWuYingFu/lookFiles.vue'
export default {
  components: {
    lookFiles
  },
  props: {
    KPJLMark: {
      type: Boolean,
      default: false
    },
    kaiPiaoJL: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      KPJLDataList: [],
      KPJLYunDanDataList: [],
      multipleSelection: [],
      lookImgMark: false,
      lookImgData: {}
    }
  },
  mounted () {
    this.getSettlementList()
  },
  methods: {
    closeDialog () {
      this.$emit('update:KPJLMark', false)
    },
    getSettlementList () {
      getInvoiceRecordMasterList(this.kaiPiaoJL).then(res => {
        this.KPJLDataList = res.list
        if (res.list.length > 0) {
          this.$refs.KPJLDataList.toggleRowSelection(this.KPJLDataList[0], true)
          this.multipleSelection = this.KPJLDataList[0]
          this.getYunDanList(this.KPJLDataList[0].id)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    rowStyle ({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', { // 给每一行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex
      })
    },
    rowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'current-row'
      }

      // let rowName = ''
      // let findRow = this.multipleSelection.find(c => c.rowIndex === row.rowIndex)
      // if (findRow) {
      //   rowName = 'current-row'
      // } else {
      //   rowName = ''
      // }
      // return rowName // 也可以再加上其他类名 如果有需求的话
    },
    selectGoods (list, item) {},
    KPJLxuanzhong (row, column, event) {
      // console.log(row,'row, column, event')
      let refsElTable = this.$refs.KPJLDataList // 获取表格对象
      let findRow = this.multipleSelection.find(c => c.rowIndex == row.rowIndex) // 找到选中的行
      if (findRow) {
        refsElTable.toggleRowSelection(row, false) // 如过重复选中，则取消选中
      } else {
        // console.log('点击选中')
        refsElTable.toggleRowSelection(row, true) // 实现选中行中选中事件
      }
      // let selectData = this.$refs.tableList.selection
      // this.selectGoods(selectData, row)
      this.getYunDanList(row.id)
      // this.$refs.KPJLDataList.toggleRowSelection(row, true)
    },
    getYunDanList (id) {
      findWayBusinessList({
        // yfSettlementBillId 应付_账单表主键id
        yfSettlementBillId: this.kaiPiaoJL.settlementBillId, // 应收_账单表主键id
        invoiceRecordId: id// 结算记录主表id
      }).then(res => {
        this.KPJLYunDanDataList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    getKPImgFn (row) {
      this.lookImgMark = true
      this.lookImgData = row
    },
    // 撤销开票
    delRecordFn (row) {
      this.$confirm('是否执行操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delInvoiceRecord({
          id: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          this.$emit('update:KPJLMark', false)
          this.$emit('refresh')
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.current-row{
  color: #409eff;
}
</style>
